import { render, staticRenderFns } from "./LandingChainContact.vue?vue&type=template&id=48454cf0&scoped=true"
import script from "./LandingChainContact.vue?vue&type=script&lang=js"
export * from "./LandingChainContact.vue?vue&type=script&lang=js"
import style0 from "./LandingChainContact.vue?vue&type=style&index=0&id=48454cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48454cf0",
  null
  
)

export default component.exports